import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Col } from '@/components/Col';
import { Flex } from '@/components/Flex';
import { LegacyButton } from '@/components/LegacyButton';
import { NextImage } from '@/components/NextImage';
import { Row } from '@/components/Row';
import type { Maybe } from '@/lib/types';
import { theme } from '@/theme';
export const Wrapper = styled(Flex)`
  padding: 30px 30px 0px 30px;
  overflow: hidden;
  flex-direction: column;
`;
export const StyledRow = styled(Row)`
  flex-direction: column;
  ${theme.media.md.up} {
    flex-direction: row;
  }
`;

export const Description = styled(Col)`
  flex-direction: column;
  word-break: break-word;
  white-space: pre-wrap;
  padding-bottom: 30px;
  display: flex;
`;

export const ProductsImages = styled(Col)`
  ${({ theme }) => css`
    ${theme.media.md.down} {
      min-height: 140px;
    }
  `};
  padding-left: 8px;
  padding-right: 8px;
`;
export const ImagesWrapper = styled(Box)``;
export const TripticImages = styled(Box)`
  bottom: 100px;
  height: 270px;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 0;
  position: absolute;
  width: 100%;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ theme }) => css`
    ${theme.media.md.up} {
      height: 320px;
      bottom: 0px;
      width: 50%;
      right: 0;
      transform: none;
    }
  `};
`;

export const MediaWrapper = styled(Box)<{
  mediaAnimationEffect: Maybe<string>;
}>`
  position: relative;
  width: 100%;
  overflow: hidden;
  ${({ mediaAnimationEffect }) => css`
    ${mediaAnimationEffect &&
    css`
      &:hover {
        cursor: pointer;
        img {
          transform: scale(1.1);
          transition: all 0.5s linear;
        }
      }
    `}
  `};
`;
export const MediaImage = styled(NextImage)`
  width: 100%;
  position: relative;
  overflow: hidden;
  height: 150px;

  inset: 0;
  object-fit: cover;
  background-position: center;

  ${({ theme }) => css`
    height: 140px;
    ${theme.media.md.up} {
      height: 174px;
    }
  `};
`;

export const Text = styled.div`
  font-size: ${theme.fontSizes.p3};
  font-family: ${theme.fontFamilies.openSans};
  line-height: 1.5;
  font-weight: ${theme.fontWeights.regular};
  ${({ color, theme }) => css`
    margin-top: ${theme.spacing(1.5)};
    text-align: center;
    letter-spacing: 0;
    color: ${color ?? theme.colors.default};
    margin-bottom: ${theme.spacing(1.5)};
    ${theme.media.md.up} {
      text-align: left;
      margin-bottom: ${theme.spacing(1)};
    }
  `}
`;

export const TeaserWrapper = styled(Box)`
  position: relative;
  margin: 0 auto;
  padding: 0 15px 0 15px;
  max-width: 1370px;
`;
export const StyledPrice = styled(Box)`
  z-index: 2;
  font-family: ${theme.fontFamilies.italianPlate};
  font-size: ${theme.fontSizes.p2};
  line-height: ${theme.lineHeights.p2};
  ${({ theme }) => css`
    text-align: center;
    letter-spacing: 0;
    text-transform: uppercase;
    font-weight: 700;
    display: flex;
    justify-content: center;
    align-items: center;

    color: ${theme.colors.navyBlueSub1};
    ${theme.media.md.up} {
      justify-content: left;
      text-align: left;
    }
  `};
`;
export const SpanCapitalize = styled.span`
  text-transform: capitalize;
`;
export const MidImageContainer = styled(Box)`
  max-width: 198px;
  height: 100%;
  text-align: center;
  cursor: pointer;
  width: 100%;

  margin-left: -110px;
  margin-right: -110px;
  ${({ theme }) => css`
    ${theme.media.sm.down} {
      max-width: 178px;
      margin-left: -100px;
      margin-right: -100px;
    }
  `};
  z-index: 1;
  img {
    transform: scale(1.5);
    width: 180px;
    aspect-ratio: auto 198 / 320;
    height: 240px;
  }
`;
export const LeftAndRightImageContainer = styled(Box)`
  max-width: 198px;
  height: 100%;
  text-align: center;
  cursor: pointer;
  width: 100%;
  ${({ theme }) => css`
    ${theme.media.sm.down} {
      max-width: 178px;
    }
  `};
  img {
    transform: scale(1.2);
    width: 180px;
    aspect-ratio: auto 198 / 320;
    height: 240px;
  }
`;
export const Cta = styled(LegacyButton)`
  ${({ theme }) => css`
    margin-top: 10px;
    display: none;
    ${theme.media.md.up} {
      display: block;
    }
  `};
`;
export const StyledIcon = styled.span`
  ${({ theme }) => css`
    text-transform: uppercase;
    font-weight: 700;
    background-color: ${theme.colors.primary};
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    color: ${theme.colors.white};
    cursor: pointer;
    font-size: 10px;
    height: 12px;
    margin-top: 1px;
    padding-top: 2px;
    width: 12px;
    margin-bottom: 3px;
  `};
`;
export const HeadingWrapper = styled(Box)`
  display: block;
  > div > span > span {
    cursor: pointer;
  }
`;
export const MobileCta = styled(LegacyButton)`
  ${({ theme }) => css`
    margin-top: 10px;
    display: none;
    ${theme.media.md.down} {
      display: block;
    }
  `};
`;
